import { Modal } from "antd";
import { API_URL } from "constants";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUpdateAppOfferMutation } from "services/auth";
import { Button } from "shared/components/Button";
import routes, { appRoute } from "shared/constants/routes";
import { LoadingOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { useTranslation } from "../../../contexts/TranslationContext";

// Helper function to get the correct version based on application source
export const getVersionForApp = (appId) => {
  // For v1 and v2 users, check application source
  try {
    const appSourceMap = JSON.parse(localStorage.getItem('userAppsSourceMap') || '{}');
    if (appSourceMap[appId]) {
      return appSourceMap[appId]
    }
  } catch (error) {
    console.error("Error checking cached app source:", error);
  }
  //fallback to v1
  return 'v1';
};

export default function AcceptModal({ appId, kastleId }) {
  let version = getVersionForApp(appId);
  const [isOpen, setIsOpen] = useState(false);
  const { translate, language } = useTranslation();

  const navigate = useNavigate();
  const [updateAppOffer, { isLoading }] = useUpdateAppOfferMutation();


  const handleConfirm = async () => {
    const errorMessage = language === 'ar'
      ? "غير قادر على قبول العرض، يرجى المحاولة مرة أخرى"
      : "Unable to accept offer, please try again";

    const successMessage = language === 'ar'
      ? "تم قبول العرض بنجاح"
      : "Offer accepted successfully";

    try {
      const response = await updateAppOffer({
        appId: appId,
        ...(version === 'v1' && kastleId ? { kastle_appl_id: kastleId } : {}),
        offerStatus: "ACCEPTED",
        apiVersion: version === 'v2' ? '2' : '1',
      });

      // Handle V2 response
      if (version === 'v2') {
        if (response?.data?.success === true) {
          toast.success(response?.data?.message || successMessage);
        } else if (response?.data?.success === false || response?.data?.error) {
          const errorMsg = response?.data?.error?.message || response?.data?.message || errorMessage;
          toast.error(errorMsg);
        } else if (response?.error) {
          toast.error(errorMessage);
        } else {
          toast.success(successMessage);
        }
      } 
      // Handle V1 response
      else {
        if (response?.data?.payload?.outBinds?.p_status) {
          toast.error(response?.data?.payload?.outBinds?.p_status);
        } else if (response?.error) {
          toast.error(errorMessage);
        } else {
          toast.success(successMessage);
        }
      }

    } catch (ex) {
      console.error("Error accepting offer:", ex);
      toast.error(errorMessage);
    } finally {
      setIsOpen(false);
      navigate(appRoute(routes.HOME));
    }
  };

  return (
    <>
      <Button onClick={() => setIsOpen(true)} color="primary" className="rounded-xl h-12 w-32">
        {translate("OFFER_TABLE.ACCEPT")}
      </Button>
      <Modal
        open={isOpen}
        title={translate("OFFER_TABLE.CONFIRM")}
        onCancel={() => setIsOpen(false)}
        footer={
          <Button disabled={isLoading} onClick={handleConfirm} color="primary" className="rounded-xl min-w-32">
            {isLoading ? <LoadingOutlined /> : translate("OFFER_TABLE.CONFIRM_BTN")}
          </Button>
        }
      >
        {translate("OFFER_TABLE.CONFIRM_ACCEPTANCE")}
      </Modal>
    </>
  );
}
